import React from 'react';

import {VersionsSidebarFactory} from 'app/components/general/VersionsSidebar';
import {useInfiniteListFetcherRTK} from 'app/general/datafetchers/hooks/useInfiniteListFetcherRTK';
import {
  convertLocationParamsToFetchParams,
  useQuizVersions,
} from 'app/quizzes/api';
import {SORT_BY_TYPES} from 'app/utils/constants';

import type {SpecificVersionsSidebarOwnProps} from 'app/components/general/VersionsSidebar';
import type {QuizVersionSerializedType} from 'sweet-types';

export const QuizVersionsSidebar = ({
  object,
  selectedVersion,
}: SpecificVersionsSidebarOwnProps) => {
  const {
    results: versions,
    refetch,
    loadNext,
    hasNext,
  } = useInfiniteListFetcherRTK({
    fetchParams: {
      quizId: object.id,
      ordering: SORT_BY_TYPES.CREATION_DATE,
    },
    useDataHook: useQuizVersions,
    paramsConverter: convertLocationParamsToFetchParams,
  });

  return (
    <VersionsSidebarComponent
      object={object}
      selectedVersion={selectedVersion}
      loadVersions={async () => refetch()}
      loadMoreVersions={async () => loadNext()}
      moreToLoad={hasNext}
      versions={versions}
    />
  );
};

const VersionsSidebarComponent =
  VersionsSidebarFactory<QuizVersionSerializedType>();
